module.exports = __webpack_public_path__ + "8a5356e9/img/cadBim.e369a02a.png";